import { Checkbox, CheckboxProps, styled } from '@mui/material';
import React, { forwardRef } from 'react';

export const CheckboxCustom = styled<React.FC<CheckboxProps>>((props) => (
    <Checkbox {...props} edge={"start"} disableRipple />
))(({ theme }) => ({
  color: theme.palette.grey[400],
  paddingRight: 0,
  "&.Mui-checked": {
    color: theme.palette.primary[500],
  },
}));
// TODO: ennek utána nézni
// eslint-disable-next-line react/display-name
const CheckboxStyled = forwardRef((props: CheckboxProps, ref) => {
  return (
      <CheckboxCustom
          {...props}
      />
  );
});

export default CheckboxStyled;
